module.exports = __webpack_public_path__ + "img/img_gnb_01.8ddb5b58.png";